export const getCentralizedCognitoPoolConfig = () => ({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL,
      userPoolClientId: process.env.REACT_APP_COGNITO_APP_ID,
      userPoolEndpoint: process.env.REACT_APP_COGNITO_APP_PROXY_ENDPOINT_URL,
    },
  },
})
